import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import orderBy from 'lodash/orderBy';

import {
  setAcademyTopicsDate,
  setConfirmationOpen,
  setScheduleClassesFormErrors,
  validateScheduleClassesForm,
} from 'features/classCreation';
import { useGetHolidayListQuery } from 'services/holidayService';
import getDatesForSchedule from 'utils/getDatesForSchedule';

function ScheduleButton() {
  const { data } = useGetHolidayListQuery();
  const holidays = data?.data;
  const dispatch = useDispatch();
  const state = useSelector((state) => state.scheduleClassesForm);

  const handleClick = useCallback(() => {
    const errors = validateScheduleClassesForm(state);
    if (Object.keys(errors).length > 0) {
      dispatch(setScheduleClassesFormErrors(errors));
    } else {
      const classes = orderBy(
        Object.values(state.academyTopics).filter((o) => o.selected),
        ['order'],
        ['asc']
      );

      const scheduleDates = getDatesForSchedule({
        holidays,
        dayTimes: state.academySchedule.dayTimes,
        start: new Date(state.startDate),
        maxDates: classes.length,
      });
      const dates = classes.reduce((dates, cls, index) => {
        return {
          ...dates,
          [cls.id]: scheduleDates[index].getTime(),
        };
      }, {});

      batch(() => {
        dispatch(setScheduleClassesFormErrors({}));
        dispatch(setAcademyTopicsDate({ dates }));
        dispatch(setConfirmationOpen(true));
      });
    }
  }, [dispatch, holidays, state]);

  return (
    <Tappable
      className="btn btn-primary btn-long"
      onClick={handleClick}
    >
      Confirm Schedule
    </Tappable>
  );
}

export default ScheduleButton;
